// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCz9XNnyUjr22NuLpelxZkRYvV39ndg98U",
  authDomain: "htmaaland.firebaseapp.com",
  projectId: "htmaaland",
  storageBucket: "htmaaland.appspot.com",
  messagingSenderId: "544211175786",
  appId: "1:544211175786:web:dbe865d719a99d39befd13",
  measurementId: "G-F8VCW1MVEQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);